export async function enqueueTourUpdate<T>(
  queues: Map<T, Promise<void>>,
  key: T,
  sendUpdate: () => Promise<void>,
): Promise<void> {
  const previousUpdate = queues.get(key);
  const nextUpdate = previousUpdate ? previousUpdate.then(sendUpdate) : sendUpdate();
  queues.set(key, nextUpdate);
  try {
    await nextUpdate;
  } finally {
    // Clear in `finally` so a rejected write cannot stay as the tail: later writes would chain
    // onto it, skip their send, and leave this tour unable to persist for the rest of the
    // session. Only clear while still the tail, or a write queued behind this one is stranded.
    if (queues.get(key) === nextUpdate) {
      queues.delete(key);
    }
  }
}
